
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/payment",
      function () {
        return require("private-next-pages/docs/errors/payment.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/payment"])
      });
    }
  